import request from '@/utils/request';
import { generateBotProof } from '@/utils/botDetector';

/**
 * 领取体验金 POST /liyuan-trade/wallet/trial/claim
 * 会话 + botProof 即可；不要求先充值 / Privy / 钱包签名。
 * 无交易地址时服务端落待入账，地址就绪后自动 mint。
 * @param {{ amount: number|string, event?: Event }} body
 * @returns {Promise<{ txHash?: string, balance: number|string, mintStatus?: 'pending'|'confirmed' }>}
 */
export async function claimTrialFund(body) {
  const amount = body?.amount;
  let botProof = '';
  try {
    botProof = await generateBotProof('trial_claim', body?.event);
  } catch (err) {
    console.warn('[trial-fund] generateBotProof error', err);
  }
  return request.post(
    '/liyuan-trade/wallet/trial/claim',
    {
      amount,
      botProof,
    },
    {
      timeout: 45000,
    }
  );
}

/**
 * 查询兑换/提现达标条件 GET /liyuan-trade/wallet/trial/withdraw-conditions
 * @param {{ currentWithdrawAmount?: number|string }} [params]
 * @returns {Promise<TrialConditionsVo>}
 */
export function getTrialWithdrawConditions(params = {}) {
  const query = {};
  if (params.currentWithdrawAmount != null && params.currentWithdrawAmount !== '') {
    query.currentWithdrawAmount = String(params.currentWithdrawAmount);
  }
  return request.get('/liyuan-trade/wallet/trial/withdraw-conditions', query);
}
